import React, { FC } from 'react'

import {
  CompositeDecorator,
} from 'draft-js'

import magicTag from './magicTag'
import link from './link'

const decorator = new CompositeDecorator([
  link,
  magicTag,
])

export default decorator